import { render } from "./AccordionItem.vue?vue&type=template&id=0f3c6b8e&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=0f3c6b8e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3c6b8e"]])

export default __exports__